import React, { useState } from 'react';
// import { Link } from 'react-router-dom';
import { Link } from 'react-scroll';
import logo from '../images/profile.jpg';
import '../css/Navbar.css';

const Navbar = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    return (
        <nav>
            <div className='navbar-container'>
                <div className='logo-container'>
                    <img src={logo} alt='LOGO' className='logo' />
                </div>
                <div className='email'>
                    <p>saif123@gmail.com</p>
                </div>

                <div className='hamburger' onClick={toggleMenu}>
                    <span className='line'></span>
                    <span className='line'></span>
                    <span className='line'></span>
                </div>

                <ul className={`nav-links ${isMenuOpen ? 'active' : ''}`}>
                    <li><Link to='home' smooth={true} duration={500}>Home</Link></li>
                    <li><Link to='about' smooth={true} duration={500}>Skills</Link></li>
                    <li><Link to='projects' smooth={true} duration={500}>Projects</Link></li>
                    <li><Link to='contact' smooth={true} duration={500}>Contact</Link></li>
                    <Link to='contact' smooth={true} duration={500}>
                        <button className='hire-me'>Hire me!</button>
                    </Link>
                </ul>
            </div>
        </nav>
    );
};

export default Navbar;
